import React from "react";
import { Link } from "react-router-dom";
import { useMasterData } from "../../../hooks/useMasterData";

function HeaderLogo() {
  const { masterData } = useMasterData();

  if (!masterData?.LogoUrl) {
    return (
      <Link to="/" style={{ textDecoration: "none" }}>
        <span style={{
          color: "#ffffff",
          fontSize: "1.5rem",
          fontWeight: 800,
          letterSpacing: "-0.04em",
          fontFamily: "'Inter', sans-serif",
        }}>
          Ads<span style={{ color: "rgba(255,255,255,0.75)" }}>One</span>
        </span>
      </Link>
    );
  }

  return (
    <Link to="/">
      <img
        src={masterData.LogoUrl}
        alt="AdsOne"
        className="header-logo-img cursor-pointer"
      />
    </Link>
  );
}

export default HeaderLogo;
